import { createSelector } from 'reselect';

const selectService = (state) => state.services;
const selectPose = createSelector(selectService, (state) => state);

const selectUpdatePos = createSelector(
	selectService,
	(state) => state?.poses?.update
);

const selectindexPos = createSelector(
	selectService,
	(state) => state?.poses?.list
);

const serviceSelectors = {
	selectService,
	selectPose,
	selectUpdatePos,
	selectindexPos,
};

export default serviceSelectors;
